import Echo from 'laravel-echo'
import _ from "lodash"
import 'promise-polyfill/src/polyfill'
import 'react-image-lightbox/style.css'
import {joinChannels} from "services/websockets/channels"
import {polyfill} from 'smoothscroll-polyfill'
import {updateUser} from "./redux/actions"
import {store} from "./store"
import {AxiosError, AxiosResponse} from "axios"

window.Popper = require('popper.js').default
window.$ = window.jQuery = require('jquery')

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.baseURL = window.app.basename
window.axios.interceptors.response.use((response: AxiosResponse) => {
  return Promise.resolve(response)
}, async (error: AxiosError) => {
  if (error && error.response && (error.response.status === 401 || error.response.status === 419)) {
    await store.dispatch(updateUser(null))
    return location.reload()
  }
  return Promise.reject(error)
})

const token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = _.get(token, 'content', false)
} else {
  console.error('CSRF token not found')
}

require('./mixins/http')

window.Pusher = require('pusher-js')

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: window.app.socket.key,
  wsHost: window.app.socket.host,
  wsPort: window.app.socket.port,
  wssPort: window.app.socket.port,
  encrypted: window.app.socket.encrypted,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  authEndpoint: window.app.basename + '/broadcasting/auth',
})

joinChannels(window.app.user)

window.__forceSmoothScrollPolyfill__ = true

polyfill()
